import tinycolor from 'tinycolor2';
import styled from 'styled-components';
import React, { memo } from 'react';
import { globalTheme, useMixin } from '@cld/component-theme';
import Tooltip from '@cld/tooltip';
import Icon from '@cld/icon';
import { colorPickerTheme } from '../theme';
import { isValidHex } from '../colorPickerUtils';
import { ColorItem } from './ColorItem';

export const CheckedIcon = styled(Icon).attrs({ name: 'check' })`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

export const Colors = memo(({ predefinedColors, handlePaletteChange, handleKeyDown, selectedColors, size }) => {
  const highContrastColor = useMixin(globalTheme.palette.surfaceAlt);
  const lowContrastColor = useMixin(globalTheme.palette.contrastLow);
  const iconSize = useMixin(colorPickerTheme.field.sizeVariant[size].checkIcon);

  return predefinedColors.map(
    (color, index) =>
      isValidHex(color, true) && (
        <Tooltip trigger={['focus', 'hover']} title={color} placement="top" key={`color ${index}`}>
          <li>
            {selectedColors?.includes(color) && (
              <CheckedIcon size={iconSize} color={tinycolor.mostReadable(color, [highContrastColor, lowContrastColor]).toHexString()} />
            )}
            <ColorItem
              key={`${color}${index}`}
              size={size}
              value={color}
              tabIndex="0"
              onClick={handlePaletteChange}
              onKeyDown={handleKeyDown}
              data-test-specifier={color}
            />
          </li>
        </Tooltip>
      )
  );
});
